import { render } from "./Progress.vue?vue&type=template&id=cb2dd264&scoped=true"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"

import "./Progress.vue?vue&type=style&index=0&id=cb2dd264&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2dd264"]])

export default __exports__